import {
  Page, Section, ElementType, EventType,
} from './constants';

export const GoogleSignupEvents = {
  usernameCompleted: () => ({
    event: 'username completed',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.input,
    },
  }),
  passwordCompleted: () => ({
    event: 'password completed',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.input,
    },
  }),
  confirmPasswordCompleted: () => ({
    event: 'confirm password completed',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.input,
    },
  }),
  emailAddressCompleted: () => ({
    event: 'email address completed',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.input,
    },
  }),
  termsOfServiceAccepted: () => ({
    event: 'terms of service accepted',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.checkbox,
      eventType: EventType.click,
    },
  }),
  termsOfServiceClicked: () => ({
    event: 'terms of service clicked',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.link,
      eventType: EventType.click,
    },
  }),
  privacyPolicyClicked: () => ({
    event: 'privacy policy clicked',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
      elementType: ElementType.link,
      eventType: EventType.click,
    },
  }),
  accountCreated: () => ({
    event: 'account created',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupForm,
    },
  }),
  returnToGoogleClicked: () => ({
    event: 'return to google clicked',
    properties: {
      page: Page.resellerGoogle,
      section: Section.googleSignupSuccess,
      elementType: ElementType.button,
      eventType: EventType.click,
    },
  }),
};
